export default "https://sdk.cotreat.ai/user-9d20b541.svg";